import React from 'react';
import LoadingCell from '../../Clinics/ClinicsList/components/Loaders/LoadingCell';
import { ClinicMasterProduct } from '../../../apis/clinic-master-products/types';

interface ClinicMasterProductsTableRow {
  view: {
    master_product_name: string | JSX.Element;
  };
  ID?: string;
  route?: string;
  headers?: boolean;
}

export const headers: ClinicMasterProductsTableRow = {
  view: {
    master_product_name: 'Master Product Name'
  },
  headers: true
};

export const prepareLoadingData = (rowsPerPage: number) => {
  return Array.from({ length: rowsPerPage }).reduce<ClinicMasterProductsTableRow[]>(
    data => {
      data.push({
        view: {
          master_product_name: <LoadingCell />
        }
      });
      return data;
    },
    [headers]
  );
};

export const convertClinicMasterProductsToTable = (data: ClinicMasterProduct[]) => {
  if (!data) {
    return [];
  }

  return data.reduce(
    (data, item) => {
      const { _id, master_medicine, clinic_id } = item;

      data.push({
        view: {
          master_product_name: master_medicine?.name || 'N/A'
        },
        ID: String(_id),
        route: `clinics/${clinic_id}/products`
      });

      return data;
    },
    [headers]
  );
};
